import { Injectable } from "@angular/core";
import { AuthService } from "../services/auth.service";
import { AngularFireDatabase } from "angularfire2/database";
import { AngularFireAuth } from "angularfire2/auth";

@Injectable()
export class UserService {
  authInstance: AngularFireAuth;
  constructor(
    private authService: AuthService,
    private db: AngularFireDatabase
  ) {
    this.authInstance = this.authService.getAngularFireAuthInstance();
  }

  async updateUserRoleStatus(userId: string, role: string, status: boolean, communityId: string): Promise<boolean> {

    try {
      const profile = await new Promise<any>(resolve => {
        this.db.object(`/profile/${userId}`).valueChanges().subscribe(data => resolve(data));
      });

      if (status) {
        const profileCommunity = profile && profile.communities ? profile.communities[communityId] : undefined;
        if (profileCommunity) {
          const data = {};
          data[role] = true;
          this.db.list(`/profile/${userId}/communities/${communityId}`).update("roles", data);
        } else {
          const community = await new Promise<any>(resolve => {
            this.db.object(`/communities/${communityId}`).valueChanges().subscribe(data => resolve(data));
          });

          if (community) {
              const data = {};
              data[role] = true;
              const communityInfo = {
                  id: communityId,
                  name: community.name,
                  roles: data
              };

              this.db.list(`/profile/${userId}/communities`).update(`${communityId}`, communityInfo);
          }
        }
      } else {
        await this.db.list(`/profile/${userId}/communities/${communityId}/roles/${role}`).remove();
        const profileRoles = await new Promise<any>(resolve => {
          this.db.object(`/profile/${userId}/communities/${communityId}/roles`).valueChanges().subscribe(data => resolve(data));
        });

        if (!profileRoles) {
          await this.db.list(`/profile/${userId}/communities/${communityId}`).remove();
        }
      }

      // true means operation was successful but it could an activate (status=true) or de-activate(status=false) operation.
      return true;
  } catch (e) {
      return false;
  }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/user/user.service.ts